/**
 * @param {string} path
 * @returns {Boolean}
 */
export function emailBody(spm, type, aeTreatments) {
  
  const body = {
    'Company': `
Dear all, 

please find attached the SPM report as detailed below.

Patient ID: ${spm.patient_id}
Report Date: ${spm.report_date}
Case type: ${spm.case_type}
Case identification number: ${spm.cin}

We remain at your disposal for any issue. 

Best regards, 
Pharmacovigilance Office`,
      
    'Medical Monitor': `
Dear medical monitor,

please find attached the SPM report as detailed below 

Patient ID: ${spm.patient_id}
Report Date: ${spm.report_date}
Case type: ${spm.case_type}
Case identification number: ${spm.cin}

We remain at your disposal for any issue. 

Best regards,
Pharmacovigilance Office

--
Only for SafetyDB registered users <a href="${window.location.href}" target="blank">click here</a>`,

  };
  return body[type];
}


export function emailSubject(spm, type) {
  const subject = {
    'Company': `Protocol ${spm.protocol.name}_SPM Patient ${spm.patient_id}_${spm.case_type}`,
    'Medical Monitor': `Protocol ${spm.protocol.name}_SPM Patient ${spm.patient_id}_${spm.case_type}`
  };
  return subject[type];
}
